import React from 'react';
import { useParams } from 'react-router-dom';
import { ProFormDigit } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import { useQuery, gql } from '@apollo/client';
import ProForm from '../../../layout/ProForm';
import { SelectBudget } from '../../../input';

const GET_BUDGETS = gql`
  query selectBudget($ids: [ID!], $projectIds: [ID!]) {
    budgets(ids: $ids, projectIds: $projectIds) {
      id
      balance
      budgetCategory {
        id
        name
      }
    }
  }
`;

const VirementForm = ({ onFinish, initialValues }) => {
  const { projectId } = useParams();
  const { data, loading } = useQuery(GET_BUDGETS, {
    variables: { projectIds: [projectId] },
  });

  return (
    <ProForm
      loading={loading}
      initialValues={initialValues}
      previousLevel={`/projects/${projectId}/budget-virement`}
      onFinish={onFinish}
    >
      <SelectBudget
        label="From Budget"
        name="fromBudget"
        projectId={projectId}
      />
      <SelectBudget
        label="To Budget"
        name="toBudget"
        projectId={projectId}
        rules={[
          {
            required: true,
            message: 'Please select to budget!',
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('fromBudget') !== value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error(
                  'Virement cannot be executed within the same budget category!'
                )
              );
            },
          }),
        ]}
      />
      <ProFormDigit
        label="Virement Amount"
        name="amount"
        width="xl"
        min={0}
        fieldProps={{ formatter: (value) => `$ ${value}`, precision: 2 }}
        rules={[
          {
            required: true,
            message: 'Please enter virement amount!',
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || !data || !getFieldValue('fromBudget')) {
                return Promise.resolve();
              }

              const budgets = data?.budgets;
              const fromBudget = budgets.find(
                ({ id }) => id === getFieldValue('fromBudget')
              );
              if (fromBudget.balance < value) {
                return Promise.reject(
                  new Error(
                    'Virement amount cannot be greater than the remaining amount of the budget category!'
                  )
                );
              }

              return Promise.resolve();
            },
          }),
        ]}
      />
    </ProForm>
  );
};

VirementForm.defaultProps = {
  initialValues: {},
};

VirementForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default VirementForm;
